import { render, staticRenderFns } from "./FornecedorTabList.vue?vue&type=template&id=c5e295f4&scoped=true"
import script from "./FornecedorTabList.vue?vue&type=script&lang=js"
export * from "./FornecedorTabList.vue?vue&type=script&lang=js"
import style0 from "./FornecedorTabList.vue?vue&type=style&index=0&id=c5e295f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e295f4",
  null
  
)

export default component.exports